import { Loading } from '@topconagriculture/react-components';
import * as React from 'react';
import { WeatherError } from './WeatherError';
import { WeatherContent } from './WeatherContent';
import { useWeatherParams } from './useWeatherParams';
import { useWeatherQuery } from './useWeatherQuery';
import { configureModalMap } from '@topconagriculture/modal';
import { widgetWeatherEditModalName } from './WeatherWidgetConfig';
import WeatherChangeWidgetForm from './WeatherChangeWidgetForm';
configureModalMap({
    [widgetWeatherEditModalName]: React.createElement(WeatherChangeWidgetForm, null),
});
const WeatherWidget = ({ widget }) => {
    const params = useWeatherParams(widget);
    const { isLoading, isError } = useWeatherQuery(params);
    return (React.createElement(Loading, { isLoading: isLoading || !widget.config }, isError ? React.createElement(WeatherError, null) : React.createElement(WeatherContent, { widget: widget })));
};
export default WeatherWidget;
//# sourceMappingURL=WeatherWidget.js.map